export const mockPrograms = [
  {
    id: "1",
    title: "Mindset Reset Masterclass",
    category: "Mindset",
    coach: "Dr. Amara Osei",
    coachAvatar: "https://public.readdy.ai/ai/img_res/3fe080580edccae389656cc8c894c527.jpg",
    price: 97,
    rating: 4.9,
    reviews: 312,
    cover: "https://readdy.ai/api/search-image?query=abstract%20mind%20brain%20neural%20network%20glowing%20teal%20violet%20cosmic%20meditation%20peaceful%20serene%20artistic%20digital%20art&width=400&height=280&seq=prog1&orientation=landscape",
    description: "Break limiting beliefs and rewire your mind for success with proven neuroscience-backed techniques.",
    duration: "8 weeks",
    lessons: 24,
    level: "Beginner",
    tag: "Bestseller",
  },
  {
    id: "2",
    title: "Career Accelerator Blueprint",
    category: "Career",
    coach: "Marcus Elliot",
    coachAvatar: "https://readdy.ai/api/search-image?query=professional%20black%20man%20business%20coach%20confident%20portrait%20clean%20background&width=80&height=80&seq=av2&orientation=squarish",
    price: 149,
    rating: 4.8,
    reviews: 198,
    cover: "https://readdy.ai/api/search-image?query=career%20growth%20upward%20arrow%20golden%20light%20professional%20success%20abstract%20geometric%20warm%20tones&width=400&height=280&seq=prog2&orientation=landscape",
    description: "Land your dream role, negotiate your worth, and build a career that aligns with your purpose.",
    duration: "6 weeks",
    lessons: 18,
    level: "Intermediate",
    tag: "Top Rated",
  },
  {
    id: "3",
    title: "Corporate Leadership Edge",
    category: "Corporate",
    coach: "Sophia Hartmann",
    coachAvatar: "https://readdy.ai/api/search-image?query=professional%20european%20woman%20executive%20coach%20portrait%20clean%20studio%20background&width=80&height=80&seq=av3&orientation=squarish",
    price: 249,
    rating: 4.9,
    reviews: 145,
    cover: "https://readdy.ai/api/search-image?query=corporate%20leadership%20team%20success%20boardroom%20abstract%20geometric%20dark%20teal%20gold%20professional&width=400&height=280&seq=prog3&orientation=landscape",
    description: "Transform your leadership style, inspire teams, and drive organizational excellence.",
    duration: "10 weeks",
    lessons: 30,
    level: "Advanced",
    tag: "Premium",
  },
  {
    id: "4",
    title: "Life Blueprint: Design Your Future",
    category: "Life",
    coach: "Kenji Nakamura",
    coachAvatar: "https://readdy.ai/api/search-image?query=professional%20asian%20man%20life%20coach%20smiling%20portrait%20warm%20background&width=80&height=80&seq=av4&orientation=squarish",
    price: 79,
    rating: 4.7,
    reviews: 421,
    cover: "https://readdy.ai/api/search-image?query=life%20journey%20path%20sunrise%20mountains%20horizon%20peaceful%20nature%20abstract%20artistic%20warm%20golden&width=400&height=280&seq=prog4&orientation=landscape",
    description: "Craft a life vision, set powerful goals, and build daily habits that create lasting transformation.",
    duration: "5 weeks",
    lessons: 15,
    level: "Beginner",
    tag: "Popular",
  },
  {
    id: "5",
    title: "Inner Confidence Unlocked",
    category: "Mindset",
    coach: "Layla Hassan",
    coachAvatar: "https://readdy.ai/api/search-image?query=professional%20middle%20eastern%20woman%20coach%20confident%20portrait%20studio%20warm%20tones&width=80&height=80&seq=av5&orientation=squarish",
    price: 119,
    rating: 4.8,
    reviews: 267,
    cover: "https://readdy.ai/api/search-image?query=confidence%20empowerment%20woman%20silhouette%20sunrise%20golden%20light%20abstract%20artistic%20uplifting&width=400&height=280&seq=prog5&orientation=landscape",
    description: "Overcome self-doubt, build unshakeable confidence, and show up powerfully in every area of life.",
    duration: "7 weeks",
    lessons: 21,
    level: "Beginner",
    tag: "New",
  },
  {
    id: "6",
    title: "Wellness & Resilience Code",
    category: "Wellness",
    coach: "Dr. Priya Sharma",
    coachAvatar: "https://readdy.ai/api/search-image?query=professional%20indian%20woman%20wellness%20coach%20smiling%20portrait%20clean%20background&width=80&height=80&seq=av6&orientation=squarish",
    price: 89,
    rating: 4.6,
    reviews: 189,
    cover: "https://readdy.ai/api/search-image?query=wellness%20meditation%20zen%20lotus%20flower%20calm%20water%20reflection%20serene%20abstract%20artistic%20teal&width=400&height=280&seq=prog6&orientation=landscape",
    description: "Build mental resilience, manage stress, and create a sustainable wellness practice for life.",
    duration: "6 weeks",
    lessons: 18,
    level: "Beginner",
    tag: "Trending",
  },
];

export const mockCategories = [
  { id: "all", label: "All Programs" },
  { id: "mindset", label: "Mindset" },
  { id: "life", label: "Life Coaching" },
  { id: "career", label: "Career" },
  { id: "corporate", label: "Corporate" },
  { id: "wellness", label: "Wellness" },
];
